"use client";

import { faHeart } from "@fortawesome/pro-solid-svg-icons";
import { Icon } from "@/components/ui/Icon";
import { useWishlist } from "./WishlistContext";

export function WishlistButton({
	productId,
	className = "",
}: {
	productId: string;
	className?: string;
}) {
	const { has, toggle } = useWishlist();
	const active = has(productId);

	return (
		<button
			type="button"
			onClick={() => toggle(productId)}
			aria-pressed={active}
			aria-label="wishlist"
			className={`grid place-items-center rounded-full border border-border bg-bg/80 p-1.5 transition hover:bg-surface-2 ${className}`}
		>
			<Icon icon={faHeart} size={16} className={active ? "text-danger" : "text-muted-foreground"} />
		</button>
	);
}
